////////////// JQUERY CONFLICT NO PLEASE

(function ($) {

    ///////////////////////////////////
    ///////     FUNCTIONS     /////////
    ///////////////////////////////////

    ///////////////////////////////////
    /////// END GENERAL FUNCTIONS /////
    ///////////////////////////////////

    ///////////////////////////////////
    //////// THEME FUNCTIONS //////////
    ///////////////////////////////////

    window.hotel_offers = window.hotel_offers || function () {
        // check if i am in the hommmmme
        if (jQuery('body').hasClass('home')) {
            var offers_triggered = false;
            // check on scroll
            jQuery(window).scroll(function () {
                // limit of the offers
                var waypoint = jQuery('#offers_home').offset().top;
                if (jQuery(window).scrollTop() >= (waypoint - jQuery(window).height()) && !offers_triggered) {
                    // checker
                    offers_triggered = true;
                    // go offers
                    webSdkOffers();
                }
            });
        } else if (jQuery('body').hasClass('rooms')) {
            var rooms_offers_triggered = false;
            // check on scroll
            jQuery(window).scroll(function () {
                // limit of the offers
                var waypoint = jQuery('#children').offset().top;
                if (jQuery(window).scrollTop() >= (waypoint - jQuery(window).height()) && !rooms_offers_triggered) {
                    // checker
                    rooms_offers_triggered = true;
                    // go offers
                    webSdkOffers();
                }
            });
        } else {
            webSdkOffers();
        }
    };

    ///////////////////////////////////
    ///////   END FUNCTIONS   /////////
    ///////////////////////////////////

    window.popup_all_pages = window.popup_all_pages || function () {
        if ($('#popup_wrapper').size() > 0) {
            $.fancybox.open({
                src: '#popup_wrapper',
                type: 'inline'
            });
        }
    };

    window.forest_minigallery = window.forest_minigallery || function () {
        $("[data-desktop-fancybox]").fancybox({

            afterLoad: function (instance, slide) {
                jQuery('.slick-slider').slick('setPosition');
            }

        }).mouseover(function () {
            $(this).trigger("click");

        });
        $("[data-tablet-fancybox]").fancybox({
            afterLoad: function (instance, slide) {
                jQuery('.slick-slider').slick('setPosition');
            }
        });
        // $('.forest_slideshow').not('slick-initialized').slick({
        $('.forest_slideshow').slick({
            prevArrow: '<a href="javascript:;" class="prev "><span class="fa fa-chevron-left"></span></a>',
            nextArrow: '<a href="javascript:;" class="next "><span class="fa fa-chevron-right"></span></a>'
        })
    };


    // function that controls the height of slideshow
    window.mobileSlideshowHeightWithVideo = window.mobileSlideshowHeightWithVideo || function () {
        var sshow_wrap = jQuery('#slideshow_wrapper'),
            height;
        if (sshow_wrap.hasClass('homepage') && (window.is_mobile || window.is_phone)) {
            if (sshow_wrap.length === 0) return;

            //vars
            var video_wrapper = $('.player_wrapper'),
                video_wrapper_h,
                guest_account_h;
            if (video_wrapper.length > 0) {
                if (video_provider !== 'MP4 file') {
                    video_wrapper_h = video_wrapper.find('iframe').height();
                } else {
                    video_wrapper_h = video_wrapper.find('video').height();
                }

                // homepage
                window.addEventListener('DOMContentLoaded', function () {
                    if ($('#guestaccount_box .guestaccount_msg').children().length > 0) {
                        setTimeout(function () {
                            guest_account_h = $('#guestaccount_box').height();
                            height = parseInt((video_wrapper_h + guest_account_h), 10);
                            sshow_wrap.css({
                                height: height,
                                'max-height': height,
                                'min-height': height
                            });
                            console.log('height >', height);
                        }, 500);
                    }
                });
                window.addEventListener('resize', function () {
                    var screenOrientation = ($(window).width() > $(window).height()) ? 90 : 0;
                    if (screenOrientation === 0) {
                        if ($('#guestaccount_box .guestaccount_msg').children().length > 0) {
                            setTimeout(function () {
                                guest_account_h = $('#guestaccount_box').height();
                                height = parseInt((video_wrapper_h + guest_account_h), 10);
                                sshow_wrap.css({
                                    height: height,
                                    'max-height': height,
                                    'min-height': height
                                });
                            }, 500);
                        }
                    }
                });
            }
        }
    };



    window.slideshow_video = window.slideshow_video || function () {
        var player_icon = $('.play-icon-video'),
            slideshow_container = $('#slideshow');

        if (slideshow_container.hasClass('videoOn')) {
            var player = new Plyr('#player', {
                volume: 0,
                muted: true,
                autoplay: true,
                controls: ['play-large'],
                debug: false,
                loop: { active: true },
                storage: {
                    enabled: false
                }
            });

            player.play();
            //mobileSlideshowHeightWithVideo();
        }

        //COMMENTED THE PREVIOUS FUNCTIONS VIDEO
        // if(player_icon.length > 0){
        //     var player = new Plyr('#player', {
        //         volume: 0,
        //         muted: true,
        //         autoplay: true,
        //         controls: ['play-large'],
        //         // debug: true,
        //         loop: {active:true},
        //         storage:{
        //             enabled: false
        //         }
        //     });
        //
        //     player.on('playing',function (){
        //         $('body').addClass('playing_video');
        //     });
        //     player.on('ended', function(){
        //         $('body').removeClass('playing_video');
        //     });
        //
        //         if(video_provider !== 'MP4 file'){
        //
        //         $('#slideshow_wrapper .cycle').slick('slickPause');
        //         $('.player_wrapper').fadeIn('fast');
        //         setTimeout(function (){
        //             player.play();
        //             setTimeout(function(){
        //                 mobileSlideshowHeightWithVideo();
        //             },300);
        //         },1000);
        //
        //         // player.on('ended', function(){
        //         //     player.stop();
        //         //     $('.player_wrapper').fadeOut('fast');
        //         //     slideshowHeight();
        //         //     $('#slideshow_wrapper .cycle').slick('slickPlay');
        //         // });
        //
        //         player_icon.on('click', function(){
        //             $('#slideshow_wrapper .cycle').slick('slickPause');
        //             $('.player_wrapper').fadeIn('fast');
        //             setTimeout(function (){
        //                 // mobileSlideshowHeightWithVideo();
        //                 player.play();
        //                 setTimeout(function(){
        //                     mobileSlideshowHeightWithVideo();
        //                 },300);
        //             },1000);
        //
        //             // player.on('ended', function(){
        //             //     player.stop();
        //             //     $('.player_wrapper').fadeOut('fast');
        //             //     slideshowHeight();
        //             //     $('#slideshow_wrapper .cycle').slick('slickPlay');
        //             // });
        //         });
        //
        //         $('.controls a.stop').on('click', function () {
        //             player.stop();
        //             player.volume = 0;
        //             $('.player_wrapper').fadeOut('fast');
        //             slideshowHeight();
        //             $('#slideshow_wrapper .cycle').slick('slickPlay');
        //         });
        //         $('.controls a.pause').on('click', function () {
        //             player.pause();
        //             $(this).hide();
        //             $('.controls .muted_to_play').show();
        //         });
        //         $('.controls a.muted_to_play').on('click', function () {
        //             player.play();
        //             $(this).hide();
        //             $('.controls .pause').show();
        //             $('.controls .unmute').hide();
        //             $('.controls .mute').show();
        //         });
        //         $('.controls a.mute').on('click', function () {
        //             player.volume = 0;
        //             $(this).hide();
        //             $('.controls .unmute').show();
        //         });
        //         $('.controls a.unmute').on('click', function () {
        //             player.volume = 0.5;
        //             $(this).hide();
        //             $('.controls .mute').show();
        //         });
        //     } else {
        //         $('.player_wrapper').fadeIn('fast');
        //         setTimeout(function (){
        //             // mobileSlideshowHeightWithVideo();
        //             $('video').get(0).play();
        //             setTimeout(function(){
        //                 mobileSlideshowHeightWithVideo();
        //             },300);
        //         },300);
        //
        //         // player.on('ended',function(){
        //         //     player.stop();
        //         //     $('.player_wrapper').fadeOut('fast');
        //         //     slideshowHeight();
        //         //     $('#slideshow_wrapper .cycle').slick('slickPlay');
        //         // });
        //
        //         player_icon.on('click', function(){
        //             $('#slideshow_wrapper .cycle').slick('slickPause');
        //             $('.player_wrapper').fadeIn('fast');
        //             setTimeout(function (){
        //                 // mobileSlideshowHeightWithVideo();
        //                 player.play();
        //                 setTimeout(function(){
        //                     mobileSlideshowHeightWithVideo();
        //                 },300);
        //             },300);
        //         });
        //
        //         $('.controls a.stop').on('click', function () {
        //             player.stop();
        //             player.currentTime = 0;
        //             player.volume = 0;
        //             $('.player_wrapper').fadeOut('fast');
        //             slideshowHeight();
        //             $('#slideshow_wrapper .cycle').slick('slickPlay');
        //         });
        //         $('.controls a.pause').on('click', function () {
        //             player.pause();
        //             $(this).hide();
        //             $('.controls .muted_to_play').show();
        //         });
        //         $('.controls a.muted_to_play').on('click', function () {
        //             player.play();
        //             $(this).hide();
        //             $('.controls .pause').show();
        //             $('.controls .unmute').hide();
        //             $('.controls .mute').show();
        //         });
        //         $('.controls a.mute').on('click', function () {
        //             player.volume = 0;
        //             $(this).hide();
        //             $('.controls .unmute').show();
        //         });
        //         $('.controls a.unmute').on('click', function () {
        //             player.volume = 0.5;
        //             $(this).hide();
        //             $('.controls .mute').show();
        //         });
        //             var sshow_wrap = jQuery('#slideshow_wrapper');
        //             if(sshow_wrap.hasClass('homepage') && (window.is_mobile || window.is_phone)) {
        //                 /**
        //                  * Fixes pausing on click on mobile
        //                  * https://github.com/sampotts/plyr/issues/718
        //                  */
        //                 const videoWrapper = document.getElementsByClassName("plyr__video-wrapper")[0];
        //                 videoWrapper.addEventListener("click", event => {
        //                     player.togglePlay();
        //                     event.stopPropagation(); // Necessary or the video will toggle twice => no playback
        //                 });
        //
        //                 player.toggleControls(false);
        //             }
        //     }
        //
        // }
    };


    window.filter_btns = window.filter_btns || function () {
        var wrap = $('.elements_to_filter'),
            btns = $('.filters'),
            result = $('.no_elements_found');

        if (wrap.length > 0 && btns.length > 0) {
            var isotope_options = {
                itemSelector: '.item_wrap',
                layoutMode: 'fitRows',
                getSortData: {
                    menu_order: function (itemElem) {
                        return parseInt($(itemElem).attr('data-menu-order'), 10);
                    }
                },
                sortBy: 'menu_order',
                sortAscending: true
            };

            var $grid = wrap.isotope(isotope_options);

            var filters = {};
            btns.find('a').click(function () {
                var link = $(this),
                    buttonGroup = link.closest('.box'),
                    filterGroup = buttonGroup.attr('data-filter-group');
                filters[filterGroup] = link.attr('data-filter-value');
                var filterValue = concatValues(filters),
                    newRel = filterValue.replace('.', '');

                if ($('#photogallery').length > 0) {
                    $grid.find(filterValue).find('.thumb').attr("data-fancybox", newRel);
                }

                $grid.isotope({
                    filter: filterValue,
                    sortBy: 'menu_order',
                    sortAscending: true
                });

                link.closest('.filters').find('a').removeClass('active');
                link.addClass('active');
                $grid.on('arrangeComplete', function () {
                    // myLazyLoad.update();
                    var itemsResult = wrap.find('.item_wrap:visible');
                    itemsResult.removeClass('odd');
                    itemsResult.removeClass('even');
                    if (itemsResult.length == 0) {
                        result.show();
                    } else {
                        result.hide();
                        var i = 0;
                        itemsResult.each(function () {
                            if (i % 2 == 0) {
                                $(this).addClass('odd');
                            } else {
                                $(this).addClass('even');
                            }
                            i++;
                        })
                    }
                });
            });


            function concatValues(obj) {
                var value = '';
                for (var prop in obj) {
                    value += obj[prop];
                }
                return value;
            }
        }
    };

    window.filter_select = window.filter_select || function () {
        var $container = $('.elements_to_filter'),
            select = $('select.filters'),
            result = $('.no_elements_found');
        filters = {};

        if ($container.length > 0 && select.length > 0) {
            var isotope_options = {
                itemSelector: '.item_wrap',
                layoutMode: 'fitRows',
                getSortData: {
                    menu_order: function (itemElem) {
                        return parseInt($(itemElem).attr('data-menu-order'), 10);
                    }
                },
                sortBy: 'menu_order',
                sortAscending: true
            };
            var $grid = $container.isotope(isotope_options);

            select.change(function () {
                var $this = $(this);
                var group = $this.attr('data-filter-group');

                filters[group] = $this.find(':selected').attr('data-filter-value');
                var isoFilters = [];
                for (var prop in filters) {
                    isoFilters.push(filters[prop])
                }
                var selector = isoFilters.join(''),
                    newRel = selector.replace('.', '');
                if ($('#photogallery').length > 0) {
                    $container.find(selector).find('.thumb').attr("data-fancybox", newRel);
                }


                $container.isotope({
                    filter: selector,
                    sortBy: 'menu_order',
                    sortAscending: true
                });

                $grid.off('arrangeComplete').on('arrangeComplete', function () {
                    // myLazyLoad.update();
                    var itemsResult = $container.find('.item_wrap:visible');
                    if (itemsResult.length == 0) {
                        result.show();
                    } else {
                        result.hide();
                        var i = 0;
                        itemsResult.each(function (i) {
                            $(this).addClass(i % 2 === 0 ? 'odd' : 'even');
                        });
                    }
                });
                return false;
            });
        }
    }


    // WINDOW RESIZE
    jQuery(window).resize(function () {

        // resizing images
        resize_images();

        // detecting screen dimensions
        refresh_size_queries();

        //  slideshow height
        slideshowHeight();

        // header
        header_scroll();

        // btn for booking
        open_bf_btn();

        // carousel offers for mobile
        carousel_offers_mobile();

        //resize for video in home
        if ($('body').hasClass('front_page')) {
            mobileSlideshowHeightWithVideo();
        }

    });

    // WINDOW SCROLL
    $(window).scroll(function () {

        // header
        header_scroll();

        // btn for booking
        open_bf_btn();

        // breadcrumb scroll
        breadcrumb_scroll();

    });


    /////////////// DOM READY
    $(document).ready(function () {


        // resizing images
        resize_images();

        // detecting screen dimensions
        refresh_size_queries();

        // select drop downs
        select_dd();

        // lazyloaddd
        lazy();

        // header
        header_scroll();

        //  slideshow height
        slideshowHeight();

        // SLIDESHOW
        doSlideshow('#slideshow .cycle');

        if ($('body').hasClass('front_page')) {
            //setTimeout(function(){
            slideshow_video();
            //},1000);
        }
        // lang menu open
        lang_menu_open();

        // btn for booking
        open_bf_btn();

        // mobile menu open
        mobile_menu_open();

        // opencloseviewmore
        opencloseviewmore();

        // btn scroll
        btn_scroll();

        // breadcrumb scroll
        breadcrumb_scroll();

        // offers
        // webSdkOffers();
        hotel_offers();

        // google map
        google_map();

        // children gallery
        child_gallery();

        // carousel_offers
        if (jQuery('.children_carousel').size() > 0) {
            carousel_offers();
        }

        // mobile carousel_offers
        if (jQuery('.item_carousel_mobile').size() > 0) {
            carousel_offers_mobile();
        }

        // photogallery
        window.photogallery();

        //
        popup_all_pages();
        forest_minigallery();

        //poi popup
        $('.pinpoint').on('click', function () {
            var $this = $(this);
            var id = $this.attr('data-open');
            $(id).fadeIn();
        });

        //
        // console.log(window.performance.memory);

    });

    jQuery(document).bind('gform_post_render', function () {

        // code to trigger on AJAX form render
        // gf_form();

    });

    jQuery(window).load(function () {
        // On Window Load to load better the isostope
        filter_btns();
        if (window.is_mobile) {
            filter_select();
        }


    });

})(jQuery);

